import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Typography, Toolbar } from '@material-ui/core';
import Logo from '../../assets/logo_header.png';
import LogoChatbot from '../../assets/chatbot-appbar.png';
import { LogoContainer } from './styles';
import { useHistory, useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { getDesktopMediaQuery } from '../../utils';

export default function CustomAppbar() {
  let history = useHistory();
  let location = useLocation();

  const isChatScreen = location && location.pathname === '/chat' ? true : false;
  const isDesktopOrLaptop = useMediaQuery(getDesktopMediaQuery());

  function goToHome() {
    history.push("/home");
  }

  return (
    <div>
      <AppBar>
        <Toolbar>
          <LogoContainer>
            <img src={Logo} alt="" onClick={goToHome} />
          </LogoContainer>
          {isChatScreen ?
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <img src={LogoChatbot} alt="" />
              </div>
              {isDesktopOrLaptop ?
                <div style={{ marginTop: '-7px', marginLeft: '6px' }}>
                  <Typography variant="h6">
                    <b>Ari</b>, seu atendente virtual.
                  </Typography>
                </div>
                : null}
            </div> : null}
          {isDesktopOrLaptop ? <Typography variant="h6">&nbsp;</Typography> : null}
        </Toolbar>
      </AppBar>
    </div >
  );
}